import { render, staticRenderFns } from "./formChartAccounts.vue?vue&type=template&id=71c96fed&scoped=true"
import script from "./formChartAccounts.vue?vue&type=script&lang=js"
export * from "./formChartAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c96fed",
  null
  
)

export default component.exports